import React, { useEffect } from 'react'
export type CustomHTMLProps = {
    htmlContent?: Object
}

export const CustomHTML: React.FC<CustomHTMLProps> = (props) => {
    // ======================= PROPS
    const {
        htmlContent = null
    } = props

    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://cdn.ckeditor.com/ckeditor5/29.0.0/classic/ckeditor.js' // 如果脚本是外部的
        script.async = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    )
}

// ======================= EXPORT
export default CustomHTML